import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";

export const printTrade = (user: User, tradeid: string) => {
	return httpWebApi<Blob>({
		method: "GET",
		responseType: "blob",
		timeout: 60 * 4 * 1000,
		url: "reporting/gettradeconfreport",
		params: {
			userid: user.userId,
			tradeid,
		},
	});
};

export default printTrade;
